import { CityStreetEnGbInterface } from '@app/core/interfaces/city-street.en-gb.interface';
import { CityStreetRequestInterface } from '@app/store/my-zone/address/address.service';
import { type } from '@app/store/util';
import { Action } from '@ngrx/store';
import { NotificationInterface } from 'outshared-lib';

export const LOAD_ADDRESS = type('[address] load');
export const LOAD_ADDRESS_SUCCESS = type('[address] load success');
export const LOAD_ADDRESS_ERROR = type('[address] load error');
export const RESET = type('[address] reset');

export class LoadAddress implements Action {
    readonly type = LOAD_ADDRESS;

    constructor(public payload: { address: CityStreetRequestInterface }) {}
}

export class LoadAddressSuccess implements Action {
    readonly type = LOAD_ADDRESS_SUCCESS;

    constructor(public payload: { address: CityStreetEnGbInterface }) {}
}

export class LoadAddressError implements Action {
    readonly type = LOAD_ADDRESS_ERROR;

    constructor(public payload: { errors: NotificationInterface[] }) {}
}

export class Reset implements Action {
    readonly type = RESET;
}

export type AddressActions
    = LoadAddress
    | LoadAddressSuccess
    | LoadAddressError
    | Reset;
